/**
 * Public API for Marketplace
 * This is the public API for the Marketplace service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Amount { 
    /**
     * Upper case name of the currency
     */
    currency?: Amount.CurrencyEnum;
    /**
     * Amount of currency as a decimal
     */
    value?: string;
}
export namespace Amount {
    export type CurrencyEnum = 'USDT' | 'LEE';
    export const CurrencyEnum = {
        Usdt: 'USDT' as CurrencyEnum,
        Lee: 'LEE' as CurrencyEnum
    };
}


